import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  fetchTemplates,
  checkEventTemplate,
  knowEventcode,
  saveOptionStateTheme,
  fetchWebTemplates,
  initialCheckAtThemeFunc,
} from "TemplatesAction";
import TemplateCell from "./theme-template-cell";
import { Col, Row, Container } from "react-bootstrap";
var Loader = require("react-loaders").Loader;

// import { Loader } from 'react-loaders';

class Templates extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.knowEventcode(this.props.session);
    // this.props.fetchTemplates(this.props.session);
    this.props.fetchWebTemplates(this.props.session);
    this.props.checkEventTemplate(this.props.session);
  }

  onOptionChange = (e, templateObj) => {
    let clickedValue = e.target.value;


    if (clickedValue) {
      // this.props.saveOptionStateTheme({ id: clickedValue});
      this.props.initialCheckAtThemeFunc(false);

      this.props.saveOptionStateTheme(templateObj);
    }
  };

  renderTemplateList = () => {
    let { optionStateTheme, siteDetails, redeploy, initialCheckAtTheme } =
      this.props;
    // var cols=3;
    // if(this.props.embedded){
    //   cols=5;
    // }
    var items = _.map(this.props.templates, (templateObj, index) => {
      return (
        // <Col md={4}>
        //     <label className="custom-container-radio liveqa-label" style={{ marginBottom: 5, color: '#767988', fontWeight: 'bold' }}>
        //         <div>
        //             <TemplateCell templateObj={templateObj} eventSelectedTemplate={this.props.eventSelectedTemplate} websiteCreationCallback={this.props.websiteCreationCallback} callfrom={this.props.callfrom} />
        //         </div>
        //         <input
        //             name="option"
        //             type="radio"
        //             value={templateObj.id}
        //             onChange={(e) => this.onOptionChange(e, templateObj)}
        //             checked={optionStateTheme && !_.isEmpty(optionStateTheme) && optionStateTheme.id == templateObj.id ? true : false}
        //         />
        //         <span className="radiomark"></span>
        //     </label>
        // </Col>

        <Col md={4}>
          <Col md={1} style={{ width: "5%" }}>
            <label
              className="custom-container-radio liveqa-label"
              style={{ marginBottom: 5, color: "#767988", fontWeight: "bold" }}
            >
              {/* {label} */}
              <input
                name="option"
                type="radio"
                value={templateObj.id}
                onChange={(e) => this.onOptionChange(e, templateObj)}
                checked={
                  (optionStateTheme &&
                    !_.isEmpty(optionStateTheme) &&
                    optionStateTheme.id == templateObj.id) ||
                  (redeploy &&
                    !_.isEmpty(redeploy) &&
                    redeploy.redeploy &&
                    redeploy.from != "theme" &&
                    siteDetails &&
                    siteDetails.resource &&
                    !_.isEmpty(siteDetails.resource) &&
                    siteDetails.resource[0].templateid == templateObj.id) ||
                  (initialCheckAtTheme &&
                    initialCheckAtTheme == true &&
                    siteDetails &&
                    siteDetails.resource &&
                    !_.isEmpty(siteDetails.resource) &&
                    siteDetails.resource[0].templateid == templateObj.id)
                    ? true
                    : false
                }
              />
              <span className="radiomark"></span>
            </label>
          </Col>
          <Col md={3} key={templateObj.id}>
            <TemplateCell
              templateObj={templateObj}
              eventSelectedTemplate={this.props.eventSelectedTemplate}
              websiteCreationCallback={this.props.websiteCreationCallback}
              callfrom={this.props.callfrom}
            />
          </Col>
        </Col>
      );
    });

    return items;
  };

  renderLoader = () => {
    return (
      <Loader
        type="line-scale-pulse-out-rapid"
        active
        className="template-loader-div"
      />
    );
  };

  render() {
   

    return (
      <div style={{ padding: 20 }}>
        {this.props.templates && this.props.templates.length > 0 ? (
          <Container fluid={true}>
            <Row className="show-grid">{this.renderTemplateList()}</Row>
          </Container>
        ) : (
          <div className="col-md-12 text-center">
            {this.renderLoader()}
            <div className="loader-info">{"Loading themes..."}</div>
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {

  return {
    session: state.session,
    templates: state.templates,
    eventSelectedTemplate: state.eventSelectedTemplate,
    optionStateTheme: state.optionStateTheme,

    siteDetails: state.siteDetails,
    redeploy: state.redeploy,

    initialCheckAtTheme: state.initialCheckAtTheme,
  };
}

export default connect(mapStateToProps, {
  fetchTemplates,
  checkEventTemplate,
  knowEventcode,
  saveOptionStateTheme,
  fetchWebTemplates,
  initialCheckAtThemeFunc,
})(Templates);
